import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import referralsReducer from './slices/referralsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    referrals: referralsReducer,
    // Add other reducers here
  },
});